export default "/images/vendor/flag-icon-css/flags/4x3/kp.svg?8d10def41b377b1163c50a349b8c4394";